import { FORM_ID } from "../../../../../constants/Forms";
import ReviewSignSectionHeader from "./ReviewSignSectionHeader";

function ReviewBusInfo(props) {
  const toggleForm = () => {
    props.toggleForm(FORM_ID.BUSINESS_INFO);
  };

  const { businessAddress } = props;

  const busAddress = getBusinessAddress(businessAddress);

  return (
    <div id="busnss-info">
      <ReviewSignSectionHeader
        toggleForm={toggleForm}
        id={"bus-info"}
        headerText="Business Information"
      ></ReviewSignSectionHeader>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-sm-12" id="ad">
          <h5 id="ads">Address</h5>
        </div>
        <div id="business_address" className="col-lg-9 col-md-9 col-sm-12 data">
          {busAddress}
        </div>
      </div>

      <div className="row">
        <div className="col-lg-3 col-md-3 col-sm-12" id="phone-number">
          <h5>Business Phone Number</h5>
        </div>
        <div id="businessphone" className="col-lg-9 col-md-9 col-sm-12 data">
          {props.businessAddress.businessphone.slice(-12)}
        </div>
      </div>

      {props.businessAddress.businessfax !== "" &&
        props.businessAddress.businessfax !== undefined &&
        props.businessAddress.businessfax !== "1-___-___-____" && (
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12" id="fax">
              <h5>Business Fax Number</h5>
            </div>
            <div id="business_fax" className="col-lg-9 col-md-9 col-sm-12 data">
              {props.businessAddress.businessfax.slice(-12)}
            </div>
          </div>
        )}
    </div>
  );
}

function getBusinessAddress(businessAddress) {
  let busAddress = "";
  const isThereBusUrbanization =
    businessAddress.busresurbanization !== undefined &&
    businessAddress.busresurbanization !== "" &&
    businessAddress.busresurbanization !== null;
  busAddress = `
    ${
      businessAddress.busstate === "PR" && isThereBusUrbanization
        ? `${businessAddress.busresurbanization}, `
        : ""
    }
    ${businessAddress.busaddress1}, ${
      businessAddress.busaddress2 === ""
        ? ""
        : `${businessAddress.busaddress2}, `
    }${businessAddress.buscity}, ${businessAddress.busstate}, ${
      businessAddress.buszip
    }`;

  return busAddress;
}

export default ReviewBusInfo;
